// Render text as Vue text nodes, never as user-supplied HTML.
export function previewSegments(text, inherited = {}) {
  const pattern = /\*\*([^\n*]+?)\*\*|(?<!\*)\*([^\n*]+?)\*(?!\*)|_([^\n_]+?)_/g;
  const result = [];
  let position = 0;
  for (const match of text.matchAll(pattern)) {
    if (match.index > position) result.push({ text: text.slice(position, match.index), ...inherited });
    const bold = match[1] !== undefined || match[2] !== undefined;
    const content = match[1] ?? match[2] ?? match[3];
    result.push(...previewSegments(content, { ...inherited, [bold ? 'bold' : 'italic']: true }));
    position = match.index + match[0].length;
  }
  if (position < text.length) result.push({ text: text.slice(position), ...inherited });
  return result;
}

export function bulletSelection(text, start, end) {
  const lineStart = text.lastIndexOf('\n', Math.max(0, start - 1)) + 1;
  const nextBreak = text.indexOf('\n', end);
  const lineEnd = nextBreak === -1 ? text.length : nextBreak;
  const selected = text.slice(lineStart, lineEnd).split('\n');
  const remove = selected.every(line => /^\s*• /.test(line));
  const replacement = selected.map(line => remove ? line.replace(/^\s*• /, '') : '• ' + line.replace(/^\s*(?:[•*-] |\d+\. )/, '')).join('\n');
  return { text: text.slice(0, lineStart) + replacement + text.slice(lineEnd), start: lineStart, end: lineStart + replacement.length };
}
